import { APIEntityType } from '@ardoq/api-types';
import { LabelFormattingInfo } from '@ardoq/data-model';
import type { ItemLabels } from '../types';

export type GetRelevantLabelFormattingArgs = {
  labelFormatting: LabelFormattingInfo[];
  entityTypeName: string;
  apiEntityType: APIEntityType;
};
export const getRelevantLabelFormatting = ({
  labelFormatting,
  entityTypeName,
  apiEntityType,
}: GetRelevantLabelFormattingArgs) => {
  const relevantLabelFormatting = labelFormatting.filter(
    formatting =>
      formatting.type === apiEntityType &&
      (!formatting.typeName || formatting.typeName === entityTypeName)
  );
  if (!relevantLabelFormatting.length) {
    return null;
  }
  return relevantLabelFormatting;
};

type OtherLabelText = readonly [string, string, boolean, ...unknown[]];
export const formatOtherLabel = ([
  title,
  caption,
  showTitle,
]: OtherLabelText) => (showTitle ? `${title}: ${caption}` : caption);

export const itemLabelToLegacyLabelWithFormatting = (
  itemLabels: ItemLabels
): string => {
  const entityLabel = itemLabels.mainLabel ?? '';
  const firstOtherLabel = itemLabels.otherLabels?.[0];
  if (!firstOtherLabel) {
    return entityLabel;
  }
  return `${entityLabel} [${formatOtherLabel(firstOtherLabel)}]`;
};
